import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CloseButtonStyle from './css/CloseButtonStyle'

function CloseButton(props) {
  let class_name = 'close-button'

  // See if there is className
  if (props.className) class_name = `close-button ${props.className}`

  return (
    <React.Fragment>
      <button id={props.id} onClick={props.onClick} title={props.title} className={class_name}>
        <FontAwesomeIcon icon='times'/>
      </button>
      <CloseButtonStyle options={props} />
    </React.Fragment>
  )
}

export default React.memo(CloseButton)
